export default __webpack_public_path__ + "static/media/client.fe324fae.svg";